exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#birth_year[data-v-449934bf]{min-width:70px}#birth_day[data-v-449934bf],#birth_month[data-v-449934bf]{min-width:45px}", ""]);

// exports
